/**
 * Formats exam data by parsing options and adjusting correct answer index
 * @param {Object} exam - Raw exam data from API
 * @returns {Object} Formatted exam data
 */
export const formatExamData = (exam) => {
    return {
        ...exam,
        questions: exam.questions.map(q => ({
            ...q,
            options: JSON.parse(q.options),
            correctAnswer: q.correct_answer - 1
        }))
    };
};

/**
 * Creates FormData object for exam submission
 * @param {string} examId - ID of the exam
 * @param {Array} questions - Array of questions
 * @param {Object} answers - Object containing user answers
 * @returns {FormData} FormData object ready for submission
 */
export const createExamSubmissionData = (examId, questions, answers) => {
    const formData = new FormData();
    formData.append('exam_id', examId);

    questions.forEach((q, index) => {
        formData.append(`questions[${index}].question_id`, parseInt(q.id));

        const val = answers[q.id];

        if (val === 0 || val === '0') {
            formData.append(`questions[${index}].selected_answer`, 1);
        } else if (val !== undefined && val !== null && val !== -1 && val !== "") {
            formData.append(`questions[${index}].selected_answer`, parseInt(val) + 1);
        } else {
            formData.append(`questions[${index}].selected_answer`, 0);
        }
    });

    return formData;
};

/**
 * Checks if there are any unanswered questions
 * @param {Array} questions - Array of questions
 * @param {Object} answers - Object containing user answers
 * @returns {Array} Array of unanswered questions
 */
export const getUnansweredQuestions = (questions, answers) => {
    return questions.filter(q => answers[q.id] === undefined || answers[q.id] === null || answers[q.id] === -1);
}; 